import VueCookies from 'vue-cookies';
import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index';

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/aiqp:afterRequest(.*)',
    name: 'AIQPMFe',
    component: () =>
      import(/* webpackMode: "lazy-once", webpackChunkName: "AIQP" */ '../views/AIQPMFeView.vue'),
  },
  {
    path: '/ai:afterRequest(.*)',
    name: 'AiMFe',
    component: () =>
      import(/* webpackMode: "lazy-once", webpackChunkName: "Ai" */ '../views/AiMFeView.vue'),
  },
  {
    path: '/allocators:afterRequest(.*)',
    name: 'AllocatorsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Allocators" */ '../views/AllocatorsMFeView.vue'
      ),
  },
  {
    path: '/calendar_sync',
    name: 'CalendarSync',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "CalendarSyncView" */ '../views/CalendarSyncView.vue'
      ),
    props: true,
  },
  {
    path: '/coffee_chats:afterRequest(.*)',
    name: 'CoffeeChatsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "CoffeeChats" */ '../views/CoffeeChatsMFeView.vue'
      ),
  },
  {
    path: '/connections:afterRequest(.*)',
    name: 'ConnectionsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Connections" */ '../views/ConnectionsMFeView.vue'
      ),
  },
  {
    path: '/content:afterRequest(.*)',
    name: 'ContentMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Content" */ '../views/ContentMFeView.vue'
      ),
  },
  {
    path: '/dashboard:afterRequest(.*)',
    name: 'DashboardMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Dashboard" */ '../views/DashboardMFeView.vue'
      ),
  },
  {
    path: '/event:afterRequest(.*)',
    name: 'EventMFe',
    component: () =>
      import(/* webpackMode: "lazy-once", webpackChunkName: "Event" */ '../views/EventMFeView.vue'),
  },
  {
    path: '/funds:afterRequest(.*)',
    name: 'FundsMFe',
    component: () =>
      import(/* webpackMode: "lazy-once", webpackChunkName: "Funds" */ '../views/FundsMFeView.vue'),
  },
  {
    path: '/documents:afterRequest(.*)',
    name: 'DocumentsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Documents" */ '../views/DocumentsMFeView.vue'
      ),
  },
  {
    path: '/login',
    name: 'LoginMFe:afterRequest(.*)',
    component: () =>
      import(/* webpackMode: "lazy-once", webpackChunkName: "Login" */ '../views/LoginMFeView.vue'),
  },
  {
    path: '/logout',
    name: 'Logout',
  },
  {
    path: '/success',
    name: 'Success',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Success" */ '../views/SuccessView.vue'
      ),
  },
  {
    path: '/meetings:afterRequest(.*)',
    name: 'MeetingsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Meetings" */ '../views/MeetingsMFeView.vue'
      ),
  },
  {
    path: '/messages:afterRequest(.*)',
    name: 'MessagesMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Messages" */ '../views/MessagesMFeView.vue'
      ),
  },
  {
    path: '/notifications:afterRequest(.*)',
    name: 'NotificationsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Notifications" */ '../views/NotificationsMFeView.vue'
      ),
  },
  {
    path: '/service_providers:afterRequest(.*)',
    name: 'ServiceProvidersMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "ServiceProviders" */ '../views/ServiceProvidersMFeView.vue'
      ),
  },
  {
    path: '/terms_of_service',
    name: 'TermsOfService',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "TermsOfService" */ '../views/TermsOfServiceView.vue'
      ),
  },
  {
    path: '/user:afterRequest(.*)',
    name: 'UserMFe',
    component: () =>
      import(/* webpackMode: "lazy-once", webpackChunkName: "User" */ '../views/UserMFeView.vue'),
  },
  {
    path: '/onboarding:afterRequest(.*)',
    name: 'OnboardingMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Onboarding" */ '../views/OnboardingMFeView.vue'
      ),
  },
  {
    path: '/roadshows:afterRequest(.*)',
    name: 'RoadshowsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Roadshows" */ '../views/RoadshowsMFeView.vue'
      ),
  },
  {
    path: '/contacts:afterRequest(.*)',
    name: 'ContactsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Contacts" */ '../views/ContactsMFeView.vue'
      ),
  },
  {
    path: '/inbox:afterRequest(.*)',
    name: 'InboxMFe',
    component: () =>
      import(/* webpackMode: "lazy-once", webpackChunkName: "Inbox" */ '../views/InboxMFeView.vue'),
  },
  {
    path: '/list:afterRequest(.*)',
    name: 'ListMFe',
    component: () =>
      import(/* webpackMode: "lazy-once", webpackChunkName: "List" */ '../views/ListMFeView.vue'),
  },
  {
    path: '/transactions:afterRequest(.*)',
    name: 'TransactionsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Transactions" */ '../views/TransactionsMFeView.vue'
      ),
  },
  {
    path: '/events:afterRequest(.*)',
    name: 'EventsMFe',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "Events" */ '../views/EventsMFeView.vue'
      ),
  },
  {
    path: '/redirect-auth:afterRequest(.*)',
    name: 'AuthRedirect',
    component: () =>
      import(
        /* webpackMode: "lazy-once", webpackChunkName: "AuthRedirect" */ '../views/AuthRedirectView.vue'
      ),
  },
  {
    path: '/:catchAll(.*)',
    redirect: (route) => ({
      path: '/dashboard',
      query: route.query,
    }),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    /success/,
    /login/,
    /redirect-auth/,
    /event\/registration/,
    /event\/referral/,
    /event\/updateaddress/,
    /event\/meetupinvite/,
    /event\/updatepreferences/,
    /event\/updateheadshot/,
    /event\/addcoo/,
    /roadshows\/.*\/contact/,
    /roadshows\/[^/]+\/invite\/[^/]+/,
    /roadshows\/[^/]+\/booking/,
    /roadshows\/[^/]+\/create-basic-account\/[^/]+/,
    /user\/[^/]+\/confirmation\/[^/]+/,
    /event\/details\/[^/]+\/registration/,
    /event\/details\/[^/]+\/badgeConfirmation/,
    /event\/details\/[^/]+\/contactstable/,
  ]; // All main paths that dont require auth
  const authRequired = !publicPages.some((r) => r.test(to.path));

  const token = store.getters['main/token'];
  const termsRequired = store.getters['main/termsRequired'];
  const aiqpRequired = store.getters['main/aiqpRequired'];
  const onboardingRequired = store.getters['main/onboardingRequired'];
  const tokenFromCookies = VueCookies.get('token');
  const refreshTokenFromCookies = VueCookies.get('refreshToken');

  // If user is going to the /login path but they have a token - redirect to '/'
  if (to.path.indexOf('login') >= 0 && (token || tokenFromCookies)) {
    next({ path: '/' });
  }

  const termsOfServiceRequired = termsRequired && to.path !== '/terms_of_service';
  const redirectToAiqp = aiqpRequired && to.path !== '/aiqp';
  const redirectToOnboarding = onboardingRequired && to.path !== '/onboarding';

  if (!token && tokenFromCookies) {
    store.dispatch('main/setToken', {
      token: tokenFromCookies,
      refreshToken: refreshTokenFromCookies,
    });
  }

  if (authRequired) {
    if (token || tokenFromCookies) {
      if (termsOfServiceRequired) {
        next({ path: '/terms_of_service' });
      } else if (redirectToAiqp) {
        next({ path: '/aiqp' });
      } else if (redirectToOnboarding) {
        next({ path: '/onboarding' });
      }
      next();
    } else {
      const redirect = to.fullPath;
      next({ path: '/login', query: { redirect } });
    }
  } else {
    next();
  }
});

export default router;
